export function readAppVersion(): string {
	const envVersion = import.meta.env.VITE_APP_VERSION?.trim();
	if (envVersion) return envVersion;

	const metaVersion = document
		.querySelector('meta[name="app-version"]')
		?.getAttribute("content")
		?.trim();

	if (metaVersion && !metaVersion.includes("%")) return metaVersion;

	return "dev";
}
